import React from 'react';
import PropTypes from 'prop-types';

/**
 * CgPanel is a simple container component that provides a styled panel
 * with a shadow, rounded corners, and an optional fade-in animation.
 * It serves as a wrapper for any child components or content that need to be displayed within a panel.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {React.ReactNode} props.children - The content to be displayed inside the panel.
 * @param {string} props.className - Additional CSS classes to apply to the panel.
 * @param {boolean} props.animate - Whether to apply the fade-in animation (defaults to true).
 * @returns {JSX.Element} The rendered panel component.
 */
const CgPanel = ({ className = '', children, animate = true, flat = false }) => {
  if (flat) return <>{children}</>;

  const animationClass = animate ? 'animate-fadeInUp' : '';

  return (
    <div
      className={`${className} border border-slate-200 rounded-xl bg-white p-4 z-0 ${animationClass}`}
    >
      {children}
    </div>
  );
};

CgPanel.propTypes = {
  children: PropTypes.node.isRequired, // Ensures children are provided
  className: PropTypes.string,
  animate: PropTypes.bool,
  flat: PropTypes.bool,
};

export default CgPanel;
